import React from 'react';
import PropTypes from 'prop-types';
import { Input } from 'antd';

const InputItem = (props) => {
    const { title, message, type, title_class, input_class, container_class, auto_focus, placeholder, suffix, prefix, disabled, value, name, onChange } = props;

    return (
        <div className={`ori-relative ${container_class}`}>
            {
                title && 
                <p className={`ori-b-mrgn-5 ori-capitalize-first ${title_class}`}>{title}</p>
            }
            <Input autoFocus={auto_focus} name={name} type={type} placeholder={placeholder} disabled={disabled} className={input_class} prefix={prefix} suffix={suffix} value={value} onChange={onChange} />
            {
                message && message.trim().length > 0 && 
                <p className="ori-absolute ori-align-bottom-neg-8 ori-align-left-10 ori-font-11 ori-font-warning">{message}</p>
            }
        </div>
    );
};

InputItem.propTypes = {
    title: PropTypes.string,
    message: PropTypes.string,
    placeholder: PropTypes.string,
    value: PropTypes.string,
    name: PropTypes.string,
    onChange: PropTypes.func,
    title_class: PropTypes.string,
    input_class: PropTypes.string,
    container_class: PropTypes.string,
    type: PropTypes.string,
    disabled: PropTypes.bool,
    auto_focus: PropTypes.bool,
    suffix: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
    prefix: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
};

InputItem.defaultProps = {
    input_class: "",
    container_class: "ori-tb-pad-5",
    auto_focus: false,
    disabled: false,
    suffix: null,
    prefix: null
};

export default InputItem;



// WEBPACK FOOTER //
// ./src/components/form/inputitem/index.js